const Install = () => {
    return(
        <div>
            <h3>Follow the link to install</h3>
            <a href="https://metamask.io/download.html">Meta Mask</a>
        </div>
    );
};

export default Install;